import React from "react";
import Modal from "react-bootstrap/Modal";

const WrongFileSizeModal = (props: any): JSX.Element => {
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <div className="text-center">
          <h4>Ihr Dokument ist zu groß. Es sind maximal 6MB erlaubt.</h4>

          <div className="btn btn-secondary mt-4" onClick={props.onHide}>
            ok.
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WrongFileSizeModal;
